import React from 'react';
import { BRAND_NAME, INSTAGRAM_HANDLE, INSTAGRAM_LINK, SUPPORT_EMAIL, WHATSAPP_LINK } from './Shared';
export function Footer() {
  return <>
      <section className="border-t-2 border-brand-gold/50 bg-brand-parchment py-12" aria-labelledby="ps-title" data-id="element-104" data-mp="3ggk90wy2pg0l">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="32lrnnhvi55m3">
          <h2 id="ps-title" className="font-serif text-xl font-bold text-brand-taupe" data-id="element-106" data-mp="36q93x72nl0s4">
            P.D.: Si tenés dudas, escribinos.
          </h2>
          <ul className="mt-4 space-y-2 text-sm text-brand-textLight md:text-base" data-id="element-107" data-mp="38qu4u3bljp2">
            <li data-id="element-108" data-mp="36d3cxfoatnb">
              📧 <strong className="text-brand-taupe" data-id="element-109" data-mp="3lem0o69kenno">Email:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-110" data-mp="3lggaopjasvcz">
                {SUPPORT_EMAIL}
              </a>
            </li>
            <li data-id="element-111" data-mp="29xm0kogz74j3">
              📲 <strong className="text-brand-taupe" data-id="element-112" data-mp="2a19uvpu8vuyv">Instagram:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={INSTAGRAM_LINK} data-id="element-113" data-mp="2ezuvhqdesgnu">
                {INSTAGRAM_HANDLE}
              </a>
            </li>
            <li data-id="element-114" data-mp="3gb8wp4be3gw4">
              💬 <strong className="text-brand-taupe" data-id="element-115" data-mp="3gbqy0fcwslaw">WhatsApp:</strong>{' '}
              <a className="font-semibold text-brand-goldDark hover:underline" href={WHATSAPP_LINK} data-id="element-116" data-mp="3v7zwvfsw0wms">
                Escribinos ahora
              </a>
            </li>
          </ul>
          <p className="mt-5 text-sm italic text-brand-muted" data-id="element-117" data-mp="82qu9y9z03wd">
            Te respondemos hoy. Sin demoras. Sin automatizaciones.
          </p>
        </div>
      </section>

      <footer className="bg-brand-text py-12 text-center font-sans text-white" data-id="element-118" data-mp="31umvaqetzm7">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-119" data-mp="hs1yp7lwwkdx">
          <p className="mb-3 font-serif text-2xl font-bold text-brand-gold md:text-3xl" data-id="element-120" data-mp="cth01cmb68rl">🌿 {BRAND_NAME}™</p>
          <p className="text-sm text-white/85 md:text-base" data-id="element-121" data-mp="qujkjkxnnb0e">
            El sistema definitivo de Cosmética Natural como Negocio de Vida.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm md:flex-row md:gap-7" data-id="element-122" data-mp="tv4m9yxi8y3f">
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-123" data-mp="yty0jtkm8t4n">
              📧 {SUPPORT_EMAIL}
            </a>
            <a className="transition-colors duration-150 ease-out hover:text-brand-gold" href={INSTAGRAM_LINK} data-id="element-124" data-mp="13r7n91gmeqos">
              📲 {INSTAGRAM_HANDLE}
            </a>
          </div>

          <div className="mt-10 space-y-2 border-t border-white/20 pt-6 text-xs text-white/55" data-id="element-125" data-mp="1cl2qu523g92b">
            <p data-id="element-126" data-mp="1hj4c8wmzskgy">© Visión Digital™ 2025 — Todos los derechos reservados.</p>
            <p data-id="element-127" data-mp="1mktogflyb46m">Prohibida la reproducción y redistribución sin autorización expresa.</p>
            <p data-id="element-128" data-mp="1rjemq9hn7dsf">Ley 25.326 — Protección de Datos Personales — República Argentina</p>
            <p data-id="element-129" data-mp="3obetvir7au74">Ley 11.723 — Propiedad Intelectual — República Argentina</p>
          </div>
        </div>
      </footer>
    </>;
}